var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customDateCell"},[_c('a-button',{attrs:{"type":_vm.isHoliday ? 'primary' : ''},on:{"click":function($event){$event.stopPropagation();return _vm.switchHoliday.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.isHoliday ? '不可预约' : '可预约')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }